import { Box } from '@chakra-ui/react'
import React from 'react'
import Timetable from '../components/Timetable'

const TimetableScreen = () => {
  return (
    <Box>
      <Timetable/>
    </Box>
  )
}

export default TimetableScreen
